(() => {
  if (customElements.get("a-carousel-cards")) return;

  class ACarouselCards extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.boundResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.swiperElement = this.querySelector(".a-carousel-cards__swiper");
      this.prevEl = this.querySelector(".a-carousel-cards__nav--prev");
      this.nextEl = this.querySelector(".a-carousel-cards__nav--next");
      this.mobileBreakpoint = parseInt(this.dataset.mobileBreakpoint || "767", 10);
      this.slidesPerView = parseFloat(this.dataset.slidesPerView || "4");
      this.spaceBetween = parseInt(this.dataset.spaceBetween || "20", 10);
      this.enableLoop = this.dataset.loop === "true";

      this.waitForSwiper(() => {
        this.handleResize();
        window.addEventListener("resize", this.boundResize);
      });
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.boundResize);
      this.destroySwiper();
    }

    waitForSwiper(callback, retry = 0) {
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (retry > 20) return;
      setTimeout(() => this.waitForSwiper(callback, retry + 1), 120);
    }

    shouldUseSwiper() {
      return window.innerWidth > this.mobileBreakpoint;
    }

    handleResize() {
      if (!this.swiperElement) return;
      if (this.shouldUseSwiper()) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiperInstance || typeof window.Swiper !== "function") return;

      this.swiperInstance = new window.Swiper(this.swiperElement, {
        slidesPerView: this.slidesPerView,
        spaceBetween: this.spaceBetween,
        watchOverflow: true,
        speed: 600,
        loop: this.enableLoop,
        navigation: {
          prevEl: this.prevEl,
          nextEl: this.nextEl
        }
      });
    }

    destroySwiper() {
      if (!this.swiperInstance) return;
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }

  customElements.define("a-carousel-cards", ACarouselCards);
})();
